(function(){
  var el = document.getElementById('SwKorb');
  var cfgEl = document.getElementById('SwKorbConfig');
  if (!el || !cfgEl) return;
  var C = JSON.parse(cfgEl.textContent);
  var panel = el.querySelector('.swk__panel');
  var body = el.querySelector('[data-swk-body]');
  var foot = el.querySelector('[data-swk-foot]');
  var err = el.querySelector('[data-swk-err]');
  var protectBox = el.querySelector('[data-swk-protect]');
  var giftIds = C.gifts.map(function(g){ return g.id; });
  var giftValue = {}; C.gifts.forEach(function(g){ giftValue[g.id] = g.value; });
  var G = C.groups;
  function grp(h){ for (var i = 0; i < G.length; i++) if (G[i].units[h]) return i; return -1; }
  function unitOf(h){ var g = grp(h); return g < 0 ? 0 : G[g].units[h]; }
  var compare = {};
  try { compare = JSON.parse(sessionStorage.getItem('swk-compare') || '{}'); } catch(e) {}
  var cart = null, busy = false, lastFocus = null;
  function fmt(c){
    var f = C.money || '{{amount_with_comma_separator}} €';
    var n = (c / 100).toFixed(2), parts = n.split('.');
    var gp = function(x, sep){ return x.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(m, k){
      if (k === 'amount_no_decimals') return gp(String(Math.round(c / 100)), ',');
      if (k === 'amount_no_decimals_with_comma_separator') return gp(String(Math.round(c / 100)), '.');
      if (k === 'amount_with_comma_separator') return gp(parts[0], '.') + ',' + parts[1];
      return gp(parts[0], ',') + '.' + parts[1];
    }).replace(/<[^>]*>/g, '');
  }

  function api(path, data){
    return fetch(C.root.replace(/\/$/, '') + path, data ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) } : { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) { var e = new Error(j.description || j.message || 'Fehler'); e.data = j; throw e; } return j; }); });
  }
  function declined(){ try { return JSON.parse(sessionStorage.getItem('swk-declined') || '[]'); } catch(e) { return []; } }
  function setDeclined(a){ try { sessionStorage.setItem('swk-declined', JSON.stringify(a)); } catch(e) {} }

  function packsFor(n, g){
    var u = {}, rest = Math.max(0, n);
    G[g].packs.forEach(function(p){ u[p.id] = Math.floor(rest / p.u); rest = rest % p.u; });
    return u;
  }

  /* Zielzustand: Einheiten je Produkt zählen, in Pakete bündeln, Geschenke anpassen */
  function plan(c){
    var units = 0, other = 0, per = G.map(function(){ return 0; }), current = {}, updates = {}, changed = false;
    c.items.forEach(function(it){
      current[it.variant_id] = (current[it.variant_id] || 0) + it.quantity;
      var g = grp(it.handle);
      if (g > -1) { var u = G[g].units[it.handle] * it.quantity; units += u; per[g] += u; }
      else if (giftIds.indexOf(it.variant_id) < 0 && it.variant_id !== C.protect.id) other += it.quantity;
    });
    var want = {};
    G.forEach(function(gr, i){ var p = packsFor(per[i], i); for (var k in p) want[k] = p[k]; });
    var dec = units ? declined() : [];
    if (!units) setDeclined([]);
    C.gifts.forEach(function(g){ want[g.id] = dec.indexOf(g.id) > -1 || !units ? 0 : (g.per === 'unit' ? units : 1); });
    if (!units && !other) want[C.protect.id] = 0;
    Object.keys(want).forEach(function(id){
      var have = current[id] || 0;
      if (have !== want[id]) { updates[id] = want[id]; changed = true; }
    });
    return changed ? updates : null;
  }

  function sync(){
    return api('/cart.js').then(function(c){
      var u = plan(c);
      if (!u) return c;
      return api('/cart/update.js', { updates: u });
    }).then(function(c){ cart = c; return loadCompare(c); });
  }

  function loadCompare(c){
    var need = {};
    c.items.forEach(function(it){ if (compare[it.variant_id] === undefined && giftValue[it.variant_id] === undefined) need[it.handle] = 1; });
    var hs = Object.keys(need);
    if (!hs.length) return Promise.resolve(c);
    return Promise.all(hs.map(function(h){
      return fetch(C.root.replace(/\/$/, '') + '/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
        if (p) p.variants.forEach(function(v){ compare[v.id] = v.compare_at_price || 0; });
      }).catch(function(){});
    })).then(function(){ try { sessionStorage.setItem('swk-compare', JSON.stringify(compare)); } catch(e) {} return c; });
  }

  function kloSum(c, g){
    var r = { units: 0, price: 0, was: 0 };
    c.items.forEach(function(it){
      if (grp(it.handle) !== g) return;
      r.units += G[g].units[it.handle] * it.quantity; r.price += it.final_line_price;
      r.was += (compare[it.variant_id] > it.final_price ? compare[it.variant_id] : it.final_price) * it.quantity;
    });
    return r;
  }
  function setUnits(g, n){
    lock(true); showErr('');
    return api('/cart/update.js', { updates: packsFor(n, g) }).then(function(){ return sync(); }).then(render)
      .catch(function(e){ showErr(e.message); }).then(function(){ lock(false); });
  }

  function img(src){
    if (!src) return '';
    try { var u = new URL(src, location.origin); u.searchParams.set('width', '180'); return u.toString(); } catch(e) { return src; }
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(m){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function render(){
    var c = cart, save = 0, count = 0, html = '', kloUnits = 0;
    var lines = c.items.filter(function(it){ return it.variant_id !== C.protect.id && grp(it.handle) < 0; });
    lines.sort(function(a, b){ return (giftIds.indexOf(a.variant_id) > -1) - (giftIds.indexOf(b.variant_id) > -1); });
    G.forEach(function(gr, g){
      var k = kloSum(c, g);
      if (!k.units) return;
      kloUnits += k.units;
      if (k.was > k.price) save += k.was - k.price;
      count += k.units;
      html += '<div class="swk__line" data-klo="' + g + '">' +
        '<a class="swk__img" href="' + gr.url + '"><img src="' + img(gr.image) + '" alt="" width="90" height="90" loading="lazy"></a>' +
        '<div class="swk__info"><p class="swk__name">' + esc(gr.title) + '</p>' +
        (k.units > 1 && gr.packs.length > 1 ? '<p class="swk__var swk__var--deal">Mengenpreis für ' + k.units + ' Stück</p>' : '') +
        '<div class="swk__qty"><button type="button" data-swk-q="-1" aria-label="Menge verringern">−</button><span aria-live="polite">' + k.units + '</span><button type="button" data-swk-q="1" aria-label="Menge erhöhen">+</button></div>' +
        '</div><div class="swk__pr">' + (k.was > k.price ? '<s>' + fmt(k.was) + '</s>' : '') + '<b>' + fmt(k.price) + '</b>' +
        '<button type="button" class="swk__rm" data-swk-rm aria-label="Katzenklo entfernen">Entfernen</button></div></div>';
    });
    lines.forEach(function(it){
      var gift = giftIds.indexOf(it.variant_id) > -1;
      var was = gift ? (giftValue[it.variant_id] || compare[it.variant_id] || 0) : (compare[it.variant_id] || 0);
      if (was > it.final_price) save += (was - it.final_price) * it.quantity;
      if (!gift) count += it.quantity;
      var title = esc(it.product_title.replace(/^Gratis:\s*/, ''));
      html += '<div class="swk__line' + (gift ? ' is-gift' : '') + '" data-key="' + it.key + '">' +
        '<a class="swk__img" href="' + (gift ? '#' : it.url) + '"' + (gift ? ' tabindex="-1" aria-hidden="true"' : '') + '>' + (it.image ? '<img src="' + img(it.image) + '" alt="" width="90" height="90" loading="lazy">' : '') + '</a>' +
        '<div class="swk__info"><p class="swk__name">' + (gift ? '<span class="swk__tag">Gratis</span>' + (it.quantity > 1 ? it.quantity + 'x ' : '') : '') + title + '</p>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="swk__var">' + esc(it.variant_title) + '</p>' : '') +
        (gift ? '' :
          '<div class="swk__qty"><button type="button" data-swk-q="-1" aria-label="Menge verringern">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-swk-q="1" aria-label="Menge erhöhen">+</button></div>') +
        '</div><div class="swk__pr">' + (was > it.final_price ? '<s>' + fmt(was * it.quantity) + '</s>' : '') +
        '<b' + (gift ? ' class="is-free"' : '') + '>' + (gift ? 'Gratis' : fmt(it.final_line_price)) + '</b>' +
        (gift ? '' : '<button type="button" class="swk__rm" data-swk-rm aria-label="' + title + ' entfernen">Entfernen</button>') + '</div>' +
        (gift ? '<button type="button" class="swk__rm swk__rm--x" data-swk-rm aria-label="' + title + ' entfernen">×</button>' : '') + '</div>';
    });
    if (!lines.length && !kloUnits) {
      body.innerHTML = '<div class="swk__empty"><p class="swk__empty-t">Dein Warenkorb ist leer.</p><p>Schau dich in Ruhe um, alles ist versandkostenfrei.</p><a class="swk__go swk__go--alt" href="' + C.shop + '">Produkte ansehen</a></div>';
      foot.hidden = true;
    } else {
      body.innerHTML = html;
      foot.hidden = false;
    }
    var extOnly = C.checkout && C.map && !C.map[C.protect.id];
    el.querySelector('.swk__protect').hidden = !!extOnly;
    var prot = c.items.some(function(it){ return it.variant_id === C.protect.id; });
    protectBox.checked = prot;
    el.querySelector('[data-swk-protect-price]').textContent = fmt(C.protect.price);
    el.querySelector('[data-swk-count]').textContent = count ? '(' + count + ')' : '';
    el.querySelector('[data-swk-save-row]').hidden = save <= 0;
    el.querySelector('[data-swk-save]').textContent = fmt(save);
    el.querySelector('[data-swk-total]').textContent = fmt(c.total_price);
    el.querySelector('[data-swk-go-total]').textContent = fmt(c.total_price);
    badge(count);
  }

  function badge(n){
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var b = icon.querySelector('.cart-count-bubble');
    if (!n) { if (b) b.remove(); return; }
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; icon.appendChild(b); }
    b.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="visually-hidden">' + n + ' Artikel</span>';
  }

  function showErr(t){ err.textContent = t || ''; err.hidden = !t; }
  function lock(on){ el.classList.toggle('is-busy', on); busy = on; }

  function refresh(){ lock(true); return sync().then(render).catch(function(){ showErr('Der Warenkorb konnte nicht geladen werden.'); }).then(function(){ lock(false); }); }

  function open(){
    if (!el.hidden && el.classList.contains('is-open')) return refresh();
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function(){ el.classList.add('is-open'); });
    document.documentElement.classList.add('swk-lock');
    panel.focus({ preventScroll: true });
    return refresh();
  }
  function close(){
    el.classList.remove('is-open');
    document.documentElement.classList.remove('swk-lock');
    setTimeout(function(){ if (!el.classList.contains('is-open')) el.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function add(items){
    showErr('');
    return api('/cart/add.js', { items: items }).then(open).catch(function(e){
      open().then(function(){ showErr(e.message || 'Dieser Artikel konnte nicht hinzugefügt werden.'); });
      throw e;
    });
  }

  function change(key, qty){
    lock(true); showErr('');
    return api('/cart/change.js', { id: key, quantity: qty }).then(function(){ return sync(); }).then(render)
      .catch(function(e){ showErr(e.message); }).then(function(){ lock(false); });
  }

  el.addEventListener('click', function(e){
    var t = e.target;
    if (t.closest('[data-swk-close]')) { close(); return; }
    var line = t.closest('.swk__line');
    if (!line || busy) return;
    if (line.dataset.klo !== undefined) {
      var g = Number(line.dataset.klo), units = kloSum(cart, g).units;
      if (t.closest('[data-swk-rm]')) setUnits(g, 0);
      else if (t.closest('[data-swk-q]')) setUnits(g, units + Number(t.closest('[data-swk-q]').dataset.swkQ));
      return;
    }
    var key = line.dataset.key;
    var it = cart.items.filter(function(i){ return i.key === key; })[0];
    if (!it) return;
    if (t.closest('[data-swk-rm]')) {
      if (giftIds.indexOf(it.variant_id) > -1) { var d = declined(); d.push(it.variant_id); setDeclined(d); }
      change(key, 0);
    } else if (t.closest('[data-swk-q]')) {
      change(key, Math.max(0, it.quantity + Number(t.closest('[data-swk-q]').dataset.swkQ)));
    } else if (t.closest('.swk__img') && line.classList.contains('is-gift')) e.preventDefault();
  });
  protectBox.addEventListener('change', function(){
    if (busy) return;
    lock(true);
    var p = protectBox.checked ? api('/cart/add.js', { items: [{ id: C.protect.id, quantity: 1 }] }) : api('/cart/update.js', { updates: (function(o){ o[C.protect.id] = 0; return o; })({}) });
    p.then(function(){ return sync(); }).then(render).catch(function(e){ showErr(e.message); }).then(function(){ lock(false); });
  });
  el.addEventListener('keydown', function(e){
    if (e.key === 'Escape') close();
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])');
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  /* Alle Warenkorb-Formulare und Warenkorb-Links abfangen */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]') || f.hasAttribute('data-swk-skip')) return;
    e.preventDefault(); e.stopPropagation();
    var fd = new FormData(f);
    var id = Number(fd.get('id')), q = Number(fd.get('quantity') || 1);
    if (!id) return;
    var btn = f.querySelector('[type=submit]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    add([{ id: id, quantity: q }]).catch(function(){}).then(function(){ if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }, true);
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]');
    if (!a || el.contains(a)) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);

  /* Auf der Warenkorbseite die Geschenke ebenfalls abgleichen */
  if (/\/cart\/?$/.test(location.pathname)) {
    api('/cart.js').then(function(c){ var u = plan(c); if (u) api('/cart/update.js', { updates: u }).then(function(){ location.reload(); }); });
  } else {
    api('/cart.js').then(function(c){ cart = c; var n = 0; c.items.forEach(function(it){ var u = unitOf(it.handle); if (u) n += u * it.quantity; else if (giftIds.indexOf(it.variant_id) < 0 && it.variant_id !== C.protect.id) n += it.quantity; }); badge(n); }).catch(function(){});
  }

  /* Externer Checkout: Weiterleitung ohne Referrer */
  function leave(url){
    var a = document.createElement('a');
    a.href = url; a.rel = 'noreferrer noopener'; a.referrerPolicy = 'no-referrer'; a.style.display = 'none';
    document.body.appendChild(a); a.click();
  }
  function goCheckout(){
    if (!C.checkout) { location.href = '/checkout'; return; }
    lock(true);
    sync().then(function(c){
      var items = [], skus = [], map = C.map || {};
      c.items.forEach(function(it){
        var ext = map[it.variant_id];
        if (!ext) return;
        items.push(ext + ':' + it.quantity); skus.push((it.sku || it.variant_id) + ':' + it.quantity);
      });
      var url = C.checkout.replace('{items}', items.join(',')).replace('{skus}', encodeURIComponent(skus.join(','))).replace('{total}', c.total_price);
      leave(url);
    }).catch(function(){ leave(C.checkout); }).then(function(){ setTimeout(function(){ lock(false); }, 1500); });
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('[data-swk-go], a[href$="/checkout"], a[href*="/checkout?"], button[name="checkout"], input[name="checkout"]');
    if (!t || !C.checkout) return;
    e.preventDefault(); e.stopPropagation();
    goCheckout();
  }, true);
  document.addEventListener('submit', function(e){
    var f = e.target, s = e.submitter;
    if (!C.checkout || !f.matches) return;
    if (f.matches('form[action*="/checkout"]') || (s && s.name === 'checkout')) { e.preventDefault(); e.stopPropagation(); goCheckout(); }
  }, true);

  window.SwKorb = { open: open, close: close, add: add, refresh: refresh, checkout: goCheckout };
})();
